import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, isRef as _isRef, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"display":"block"} }
const _hoisted_2 = { class: "flex items-center text-lg" }
const _hoisted_3 = { style: {"display":"block"} }
const _hoisted_4 = { class: "bg-white dark:bg-gray-900" }
const _hoisted_5 = { class: "py-8 px-4 mx-auto max-w-2xl lg:py-32" }
const _hoisted_6 = { action: "#" }
const _hoisted_7 = {
  class: "grid gap-4 sm:grid-cols-2 sm:gap-6",
  style: {"margin-top":"-25px"}
}
const _hoisted_8 = { class: "sm:col-span-2" }
const _hoisted_9 = {
  for: "name",
  class: "block mb-0 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_10 = {
  role: "status",
  style: {"display":"inline-block","margin-left":"2%"}
}
const _hoisted_11 = ["aria-hidden"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("path", {
  d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("path", {
  d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
  fill: "currentFill"
}, null, -1)
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Loading...", -1)
const _hoisted_16 = { class: "relative" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    "aria-hidden": "true",
    class: "w-5 h-5 text-gray-500 dark:text-gray-400",
    fill: "currentColor",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    id: "search"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M448.3 424.7L335 311.3c20.8-26 33.3-59.1 33.3-95.1 0-84.1-68.1-152.2-152-152.2-84 0-152 68.2-152 152.2s68.1 152.2 152 152.2c36.2 0 69.4-12.7 95.5-33.8L425 448l23.3-23.3zM120.1 312.6c-25.7-25.7-39.8-59.9-39.8-96.3s14.2-70.6 39.8-96.3 59.9-40 96.2-40c36.3 0 70.5 14.2 96.2 39.9s39.8 59.9 39.8 96.3-14.2 70.6-39.8 96.3c-25.7 25.7-59.9 39.9-96.2 39.9-36.3.1-70.5-14.1-96.2-39.8z" })
  ])
], -1)
const _hoisted_18 = ["placeholder"]
const _hoisted_19 = ["selected", "value"]
const _hoisted_20 = { class: "text-red-500 text-sm mb-0 w-full" }
const _hoisted_21 = {
  key: 0,
  class: "flex mt-2"
}
const _hoisted_22 = { class: "w-1/3 mr-2" }
const _hoisted_23 = {
  id: "forma",
  for: "forma",
  class: "block mb-0 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_24 = ["value"]
const _hoisted_25 = {
  key: 0,
  class: "w-2/3 flex"
}
const _hoisted_26 = { class: "w-1/2 mr-2" }
const _hoisted_27 = {
  for: "quantita",
  class: "block mb-0 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_28 = { class: "text-red-500 text-sm mb-0 w-full" }
const _hoisted_29 = { class: "w-1/2" }
const _hoisted_30 = {
  for: "frequenza",
  class: "block mb-0 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_31 = { class: "text-red-500 text-sm mb-0 w-full" }
const _hoisted_32 = { class: "flex mt-2" }
const _hoisted_33 = { class: "w-1/2 mr-2" }
const _hoisted_34 = {
  for: "start_date",
  class: "block mb-0 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_35 = { class: "text-red-500 text-sm mb-0 w-full" }
const _hoisted_36 = {
  key: 0,
  class: "w-1/2"
}
const _hoisted_37 = {
  for: "end_date",
  class: "block mb-0 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_38 = { key: 0 }
const _hoisted_39 = { class: "text-red-500 text-sm mb-0 w-full" }
const _hoisted_40 = { key: 0 }
const _hoisted_41 = {
  key: 1,
  class: "w-full mt-2 mr-2"
}
const _hoisted_42 = {
  for: "diagnosi",
  class: "block mb-0 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_43 = { value: "" }
const _hoisted_44 = ["value"]
const _hoisted_45 = {
  value: "0",
  style: {"font-style":"italic","background-color":"#1a576e","color":"white"}
}
const _hoisted_46 = { class: "flex mt-2" }
const _hoisted_47 = { class: "w-1/2 mr-2" }
const _hoisted_48 = {
  for: "careprovider",
  class: "block mb-0 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_49 = {
  value: "",
  selected: "",
  disabled: "",
  hidden: ""
}
const _hoisted_50 = ["value"]
const _hoisted_51 = {
  value: "0",
  style: {"font-style":"italic","background-color":"#1a576e","color":"white"}
}
const _hoisted_52 = { class: "text-red-500 text-sm mb-0 w-full" }
const _hoisted_53 = { class: "w-1/2" }
const _hoisted_54 = {
  for: "confidenzialità",
  class: "block mb-0 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_55 = ["value"]
const _hoisted_56 = { class: "w-full mb-2" }
const _hoisted_57 = {
  for: "note",
  class: "block mt-2 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_58 = { key: 0 }
const _hoisted_59 = { key: 1 }
const _hoisted_60 = {
  key: 0,
  class: "text-red-500 text-sm mb-0 w-full"
}
const _hoisted_61 = {
  key: 1,
  class: "text-red-500 text-sm mb-0 w-full"
}
const _hoisted_62 = { class: "flex justify-between mt-2" }

import { Farmaco, TblTerapie } from "@/../../EshJSLib/models/patient";
import { FaramaciCollection } from "@/../../EshJSLib/models/farmaciModel";
import { Farmaci } from "@/../../EshJSLib/models/farmaciModel";
import { filterFarmaci } from "@/../../EshJSLib/services/farmaciServices";
import { onMounted, reactive } from "vue";
import { ref } from "vue";
import { initFlowbite } from "flowbite";
import { patientStore } from "@/store/patient";
import { storeToRefs } from "pinia";
import AlertModal from "@/components/AlertModalFeedback.vue";
import { Modal } from "flowbite-vue";
import { useRouter } from "vue-router";
import { compareDates } from "@/../../EshJSLib/services/relatedFunction";
import { faR } from "@fortawesome/free-solid-svg-icons";
import { checkInterazioniFarmaco } from '@/../../EshJSLib/services/farmaciServices';


export default /*#__PURE__*/_defineComponent({
  __name: 'farmaciAggiuntiveEdit',
  emits: ["cancel"],
  setup(__props, { expose: __expose, emit }) {

const alertModal = ref<InstanceType<typeof AlertModal> | null>(null);
const store = patientStore();
const { patient } = storeToRefs(store);
let farmacoSrc = ref(false);
let terapienew = ref({} as TblTerapie);
const alertConfirmMessage = ref<null | string>(null);
const showConfirm = ref(false);
const farmacoSearch = ref("");
let resolvePromise: (value: PromiseLike<boolean> | boolean) => void;
let isOpen = ref(false);
let filteredFarmaci = {} as FaramaciCollection;
let selectedarmaco = {} as Farmaci;
const filteredFarmaciReact = reactive(filteredFarmaci);
let errors = ref([]);
let errorMessage = "Questo campo è obbligatorio!";
let dateError = ref('');
let errorsNote = ref('');

onMounted(() => {
  errors.value = [];
  initFlowbite();
});


const router = useRouter();

const handleDiagnosiChange = () => {
  if (terapienew.value.id_diagnosi === 0) {
    router.push('/Registro/Diagnosi');
  }
};

const handleCareproviderChange = () => {
  if (terapienew.value.id_prescrittore == 0) {
    router.push('/Registro/Dottori');
  }
};

async function checkDrugInteraction(idFarmaco: number): Promise<boolean> {
  try {
    farmacoSrc.value = true;

    const result = await checkInterazioniFarmaco(idFarmaco);

    if (result.esito && result.messaggiInterazioni.length > 0) {
      const messaggi = result.messaggiInterazioni
        .map((interazione: any) => `⚠️ ${interazione.farmaco_in_corso} ↔ ${interazione.interazione_con}`)
        .join('\n');

      const confirmed = confirm(`Attenzione: interazione tra farmaci!\n\n${messaggi}\n\nVuoi continuare comunque?`);
      return confirmed;
    }

    return true; // nessuna interazione, procedi
  } catch (error) {
    console.error("Errore nel controllo interazioni:", error);
    alert("Errore nel controllo delle interazioni tra farmaci.");
    return false;
  } finally {
    farmacoSrc.value = false;
  }
}

function openModal(message: string, rowData: TblTerapie): Promise<boolean> {
  errors.value = [];
  errorsNote.value = "";
  terapienew.value = rowData
  alertConfirmMessage.value = message;
  showConfirm.value = true;
  farmacoSearch.value = rowData.farmaco?.descrizione_breve
  return new Promise((resolve) => {
    resolvePromise = resolve;
  });
}

function validateDates() {
  if (!compareDates(terapienew.value.data_inizio, terapienew.value.data_fine)) {
    terapienew.value.data_fine = terapienew.value.data_inizio;
    dateError.value = "Per favore, inserisci date valide. La data di fine terapia non può essere maggiore della data d'inizio!";
  }
  else {
    dateError.value = '';
  }
}

function validateFields(): boolean {
  let hasError = false;
  errors.value = Array(7).fill(""); // Assicura che l'array di errori abbia la giusta lunghezza e venga ripulito

  // Controllo campi obbligatori in base al tipo di terapia
  let fieldsToCheck = [];

  switch(terapienew.value.tipo_terapia) {
    // Farmaci Vietati
    case '0':
      fieldsToCheck = ['id_farmaco_codifa', 'id_prescrittore', 'data_inizio', 'note']
    break;

    // Terapie in Corso
    case '1':
      fieldsToCheck = ['id_farmaco_codifa', 'id_prescrittore', 'quantita_farmaceutica', 'frequenza_farmaceutica', 'data_inizio']
    break;

    // Terapie Concluse
    case '2':
      fieldsToCheck = ['id_farmaco_codifa', 'id_prescrittore', 'quantita_farmaceutica', 'frequenza_farmaceutica', 'data_inizio', 'data_fine']
    break;
  }

  fieldsToCheck.forEach((field, index) => {
    if (!terapienew.value[field]) {
      hasError = true;
      errors.value[index] = "Questo campo è obbligatorio!";
    }
  });

  // Controllo specifico per `data_inizio`
  if (!terapienew.value.data_inizio) {
    errors.value[4] = "La data di inizio è obbligatoria!";
    hasError = true;
  }

  // Controllo sulla lunghezza della nota
  if (terapienew.value.note && terapienew.value.note.length > 100) {
    errorsNote.value = 'La nota non può superare i 100 caratteri.';
  } else {
    errorsNote.value = "";
  }

  // Controllo se la data di fine è valida
  if (terapienew.value.data_fine && new Date(terapienew.value.data_inizio) > new Date(terapienew.value.data_fine)) {
    dateError.value = "Data di fine non può essere precedente alla data di inizio!";
    hasError = true;
  } else {
    dateError.value = "";
  }

  // Se terapia vietata, assicuriamoci che il motivo sia obbligatorio
  if (terapienew.value.tipo_terapia === '0' && !terapienew.value.note) {
    errors.value[6] = "Il motivo è obbligatorio per le terapie vietate";
    hasError = true;
  }

  return !hasError;
}


function saveFarmaci() {
  terapienew.value.farmaco = selectedarmaco as Farmaco;
  if (!validateFields()) {
    return;
  }

  alertModal.value.openModal("Sei sicuro di salvare i dati?", true).then((userInput) => {
    if (userInput) {
      showConfirm.value = false;
      if (!resolvePromise) return;
      resolvePromise(true);
    }
  });
}

function closeModal() {
  showConfirm.value = false
  if (!resolvePromise) return;
  resolvePromise(false);
  emit("cancel");
}

async function onFarmacoChange(e: any) {
  isOpen.value = false;
  if (!e.target) return;

  const id = e.target.value;
  const name = e.target.options[e.target.options.selectedIndex].text;

  farmacoSearch.value = name;
  selectedarmaco = filteredFarmaciReact?.Farmaci?.at(e.target.options.selectedIndex) ?? null!;
  terapienew.value.id_farmaco_codifa = id;

  const confirmed = await checkDrugInteraction(id);
  if (!confirmed) {
    terapienew.value.id_farmaco_codifa = null;
    farmacoSearch.value = "";
    selectedarmaco = {} as Farmaci;
  }
}

function filtername() {
  farmacoSrc.value = true;
  filteredFarmaci = {};

  if (farmacoSearch.value.length < 2) {
    farmacoSrc.value = false;
    return;
  }

  var res = filterFarmaci(farmacoSearch.value);
  res.then((value) => {
    filteredFarmaciReact.Farmaci = value;
    isOpen.value = true;
    farmacoSrc.value = false;
  });
}

__expose({ openModal });

return (_ctx: any,_cache: any) => {
  return (showConfirm.value)
    ? (_openBlock(), _createBlock(_unref(Modal), {
        key: 0,
        onClose: _cache[14] || (_cache[14] = ($event: any) => (closeModal())),
        style: {"max-height":"80%"}
      }, {
        header: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t(alertConfirmMessage.value)), 1)
          ])
        ]),
        body: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("section", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("form", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$t("Farmaco")) + " * ", 1),
                      _withDirectives(_createElementVNode("div", _hoisted_10, [
                        (_openBlock(), _createElementBlock("svg", {
                          "aria-hidden": !_unref(farmacoSrc),
                          class: "w-5 h-5 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600",
                          viewBox: "0 0 100 101",
                          fill: "none",
                          xmlns: "http://www.w3.org/2000/svg"
                        }, _hoisted_14, 8, _hoisted_11)),
                        _hoisted_15
                      ], 512), [
                        [_vShow, _unref(farmacoSrc)]
                      ]),
                      _createElementVNode("div", _hoisted_16, [
                        _hoisted_17,
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          id: "farmaco",
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((farmacoSearch).value = $event)),
                          onKeyup: filtername,
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_isRef(isOpen) //@ts-ignore
 ? isOpen.value = true : isOpen = true)),
                          class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full pl-10 p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                          placeholder: _ctx.$t('Cerca farmaco')
                        }, null, 40, _hoisted_18), [
                          [_vModelText, farmacoSearch.value]
                        ])
                      ]),
                      _withDirectives(_createElementVNode("select", {
                        id: "farmacoSelect",
                        class: _normalizeClass([{ 'border-red-500': _unref(errors)[0] }, "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"]),
                        onChange: _cache[2] || (_cache[2] = ($event: any) => (onFarmacoChange($event))),
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(terapienew).id_farmaco_codifa) = $event)),
                        size: "3"
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredFarmaciReact.Farmaci, (item) => {
                          return (_openBlock(), _createElementBlock("option", {
                            selected: item.id_farmaco_codifa === [...filteredFarmaciReact.Farmaci][0].id_farmaco_codifa,
                            key: item.id_farmaco_codifa,
                            value: item.id_farmaco_codifa
                          }, _toDisplayString(item.descrizione_breve), 9, _hoisted_19))
                        }), 128))
                      ], 34), [
                        [_vShow, _unref(isOpen) === true],
                        [_vModelSelect, _unref(terapienew).id_farmaco_codifa]
                      ]),
                      _createElementVNode("p", _hoisted_20, _toDisplayString(_unref(errors)[0]), 1)
                    ]),
                    (_unref(terapienew).tipo_terapia != '0')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                          _createElementVNode("div", _hoisted_22, [
                            _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.$t("Forma")), 1),
                            _createElementVNode("input", {
                              type: "text",
                              disabled: "",
                              value: _unref(selectedarmaco).somministrazione,
                              class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                            }, null, 8, _hoisted_24)
                          ]),
                          (_unref(terapienew).tipo_terapia != '0')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                _createElementVNode("div", _hoisted_26, [
                                  _createElementVNode("label", _hoisted_27, _toDisplayString(_ctx.$t("Dose")) + " * ", 1),
                                  _withDirectives(_createElementVNode("input", {
                                    id: "dose",
                                    type: "text",
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(terapienew).quantita_farmaceutica) = $event)),
                                    class: _normalizeClass([{ 'border-red-500': _unref(errors)[2] }, "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"])
                                  }, null, 2), [
                                    [_vModelText, _unref(terapienew).quantita_farmaceutica]
                                  ]),
                                  _createElementVNode("p", _hoisted_28, _toDisplayString(_unref(errors)[2]), 1)
                                ]),
                                _createElementVNode("div", _hoisted_29, [
                                  _createElementVNode("label", _hoisted_30, _toDisplayString(_ctx.$t("Frequenza")) + " * ", 1),
                                  _withDirectives(_createElementVNode("input", {
                                    id: "frequenza",
                                    type: "text",
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(terapienew).frequenza_farmaceutica) = $event)),
                                    class: _normalizeClass([{ 'border-red-500': _unref(errors)[3] }, "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"])
                                  }, null, 2), [
                                    [_vModelText, _unref(terapienew).frequenza_farmaceutica]
                                  ]),
                                  _createElementVNode("p", _hoisted_31, _toDisplayString(_unref(errors)[3]), 1)
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_32, [
                      _createElementVNode("div", _hoisted_33, [
                        _createElementVNode("label", _hoisted_34, _toDisplayString(_unref(terapienew).tipo_terapia === '0' ? _ctx.$t("Data *") : _ctx.$t("Data inizio") + " *"), 1),
                        _withDirectives(_createElementVNode("input", {
                          type: "date",
                          id: "start_date",
                          name: "start_date",
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(terapienew).data_inizio) = $event)),
                          class: _normalizeClass([{ 'border-red-500': _unref(errors)[4] }, "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"])
                        }, null, 2), [
                          [_vModelText, _unref(terapienew).data_inizio]
                        ]),
                        _createElementVNode("p", _hoisted_35, _toDisplayString(_unref(errors)[4]), 1)
                      ]),
                      (_unref(terapienew).tipo_terapia != '0')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                            _createElementVNode("label", _hoisted_37, [
                              _createTextVNode(_toDisplayString(_ctx.$t("Data fine")), 1),
                              (_unref(terapienew).tipo_terapia === '2')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_38, " *"))
                                : _createCommentVNode("", true)
                            ]),
                            _withDirectives(_createElementVNode("input", {
                              type: "date",
                              onChange: validateDates,
                              id: "end_date",
                              name: "end_date",
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(terapienew).data_fine) = $event)),
                              class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                            }, null, 544), [
                              [_vModelText, _unref(terapienew).data_fine]
                            ]),
                            _createElementVNode("p", _hoisted_39, [
                              _createTextVNode(_toDisplayString(_unref(dateError)) + " ", 1),
                              (_unref(terapienew).tipo_terapia === '2')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_40, _toDisplayString(_unref(errors)[5]), 1))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    (_unref(terapienew).tipo_terapia != '0')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                          _createElementVNode("label", _hoisted_42, _toDisplayString(_ctx.$t("Diagnosi")), 1),
                          _withDirectives(_createElementVNode("select", {
                            onChange: handleDiagnosiChange,
                            id: "diagnosi",
                            name: "diagnosi",
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(terapienew).id_diagnosi) = $event)),
                            class: "w-full bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                          }, [
                            _createElementVNode("option", _hoisted_43, _toDisplayString(_ctx.$t("Nessuna diagnosi")), 1),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(patient).diagnosi, (item) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: item.id_diagnosi,
                                value: item.id_diagnosi
                              }, _toDisplayString(item.diagnosi_patologia), 9, _hoisted_44))
                            }), 128)),
                            _createElementVNode("option", _hoisted_45, _toDisplayString(_ctx.$t("Aggiungere nuova diagnosi")), 1)
                          ], 544), [
                            [_vModelSelect, _unref(terapienew).id_diagnosi]
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_46, [
                      _createElementVNode("div", _hoisted_47, [
                        _createElementVNode("label", _hoisted_48, _toDisplayString(_unref(terapienew).tipo_terapia === '0' ? _ctx.$t("Medico *") : _ctx.$t("Prescrittore") + " *"), 1),
                        _withDirectives(_createElementVNode("select", {
                          onChange: handleCareproviderChange,
                          id: "careprovider",
                          name: "careprovider",
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(terapienew).id_prescrittore) = $event)),
                          class: _normalizeClass([{ 'border-red-500': _unref(errors)[1] }, "w-full bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"])
                        }, [
                          _createElementVNode("option", _hoisted_49, _toDisplayString(_ctx.$t("Selezionare un Care Providers..")), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(patient).associated_doctors, (item) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: item.id_utente,
                              value: item.id_utente
                            }, _toDisplayString(item.care_provider?.fullname), 9, _hoisted_50))
                          }), 128)),
                          _createElementVNode("option", _hoisted_51, _toDisplayString(_ctx.$t("Aggiungere nuovo careprovider")), 1)
                        ], 34), [
                          [_vModelSelect, _unref(terapienew).id_prescrittore]
                        ]),
                        _createElementVNode("p", _hoisted_52, _toDisplayString(_unref(errors)[1]), 1)
                      ]),
                      _createElementVNode("div", _hoisted_53, [
                        _createElementVNode("label", _hoisted_54, _toDisplayString(_ctx.$t("Livello di confidenzialità")) + " * ", 1),
                        _withDirectives(_createElementVNode("select", {
                          id: "confidenzialità",
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(terapienew).id_livello_confidenzialita) = $event)),
                          class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(patient).liveli_confidencialita, (item, key) => {
                            return (_openBlock(), _createElementBlock("option", {
                              value: item.id_livello_confidenzialita,
                              key: key
                            }, _toDisplayString(item.confidenzialita_descrizione), 9, _hoisted_55))
                          }), 128))
                        ], 512), [
                          [_vModelSelect, _unref(terapienew).id_livello_confidenzialita]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_56, [
                      _createElementVNode("label", _hoisted_57, [
                        (_unref(terapienew).tipo_terapia != '0')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_58, _toDisplayString(_ctx.$t("Note")), 1))
                          : (_openBlock(), _createElementBlock("div", _hoisted_59, _toDisplayString(_ctx.$t("Motivo")) + " *", 1))
                      ]),
                      _withDirectives(_createElementVNode("textarea", {
                        id: "note",
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(terapienew).note) = $event)),
                        class: "block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      }, "\n                  ", 512), [
                        [_vModelText, _unref(terapienew).note]
                      ]),
                      (_unref(terapienew).tipo_terapia === '0')
                        ? (_openBlock(), _createElementBlock("p", _hoisted_60, _toDisplayString(_unref(errors)[6]), 1))
                        : _createCommentVNode("", true),
                      (_unref(errorsNote))
                        ? (_openBlock(), _createElementBlock("p", _hoisted_61, _toDisplayString(_unref(errorsNote)), 1))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_62, [
              _createElementVNode("button", {
                onClick: _cache[12] || (_cache[12] = ($event: any) => (closeModal())),
                type: "button",
                class: "text-gray-500 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-blue-300 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600"
              }, _toDisplayString(_ctx.$t("Annulla")), 1),
              _createElementVNode("button", {
                id: "submit",
                onClick: _cache[13] || (_cache[13] = ($event: any) => (saveFarmaci())),
                type: "button",
                class: "text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
              }, _toDisplayString(_ctx.$t("Salva")), 1)
            ]),
            _createVNode(AlertModal, {
              ref_key: "alertModal",
              ref: alertModal
            }, null, 512)
          ])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})